import { useContext } from 'react';
import {
    CalculatorInputFields,
    CalculatorInputFieldsType,
    CalculatorInputOptions,
} from '../utils/CalculatorInputValue';
import { CalculatorFieldsContext, CalculatorOutputFieldsContext } from '../contexts/CalculatorContext';
import { CalculatorCurrencyContext, CalculatorHtmModeContext } from '../../../shared/contexts/CalculatorContext';
import { CalculatorHTMMode } from '../../../shared/classes/CalculatorMode';

export function SharedInputEdit({inputName}: { inputName: keyof CalculatorInputFieldsType }): JSX.Element | null {
    const [calculatorValue, setCalculatorValue] = useContext(CalculatorFieldsContext)!;
    const calculatorMode = useContext(CalculatorHtmModeContext)!;
    const calculatorCurrencyContext = useContext(CalculatorCurrencyContext)!;
    const label = CalculatorInputFields.find(e => e.key === inputName)?.label;
    const options = CalculatorInputOptions[inputName];
    const currency = options?.displayCurrency ? calculatorCurrencyContext[0] : '';
    const isAdvancedMode = options?.isHTMMode || false;
    const uniqInputName = 'input_' + inputName;

    return !isAdvancedMode || calculatorMode[0] === CalculatorHTMMode.HTM
        ? (
            <div className={(isAdvancedMode ? 'advancedMode ' : '') + 'inputValue'}>
                <label htmlFor={uniqInputName}>{label}</label>
                <div>{ currency ? <span>{currency}</span> : '' }</div>
                <input name={inputName} id={uniqInputName}
                       type="number"
                       onChange={event => setCalculatorValue({
                           ...calculatorValue,
                           [inputName]: event.target.value
                       })}
                       value={calculatorValue[inputName] || ''}/>
            </div>
        )
        : null;
}

export function SharedOutputEditComponent({inputName}: { inputName: string}): JSX.Element | null {

    const calculatorMode = useContext(CalculatorHtmModeContext)!;
    const calculatorCurrencyContext = useContext(CalculatorCurrencyContext)!;
    const calculatorOutputFieldsContext = useContext(CalculatorOutputFieldsContext)!;
    const {label, value, options} = calculatorOutputFieldsContext.values[inputName];
    const currency = options?.displayCurrency ? calculatorCurrencyContext[0] : '';
    const isAdvancedMode = options?.isHTMMode || false;

    return !isAdvancedMode || calculatorMode[0] === CalculatorHTMMode.HTM
        ? (
            <div className="inputValue">
                <label htmlFor={inputName}>{label}</label>
                <div>{ currency ? <span>{currency}</span> : '' }</div>
                <input name={inputName}
                       readOnly
                       type="text"
                       value={Math.round(value || 0)}/>
            </div>
        )
        : null;
}
